import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button as MUIButton, Modal, CircularProgress, IconButton } from '@mui/material';
import Services from 'src/services/Services';
import Iconify from 'src/components/iconify';

export function BolparaEsnafCompanyCampaigns() {
  const parsedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const token = parsedUser?.token;
  const { companyID } = useParams();
  const { state } = useLocation();
  const company = state?.company || {};
  const navigate = useNavigate();

  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  // Bilgilendirme modalı
  const [modalOpen, setModalOpen] = useState(false);

  // Kullanıcının EasyPoint ID'si (poiID)
  const [poiID, setPoiID] = useState("");

  // Şirket seviyesinde kupon durumu
  const [hasCoupon, setHasCoupon] = useState(null);
  const [hadCoupon, setHadCoupon] = useState(null);

  // Kupon modalı ve içerikleri
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [couponError, setCouponError] = useState("");

  // Kampanya bazlı kupon durumu (kupon bitmiş mi? var mı?)
  const [campaignCoupons, setCampaignCoupons] = useState({}); // { [campaignID]: { hasCoupon: boolean, hadCoupon: boolean } }

  // Kampanyaya tıklama
  const handleCampaignClick = (campaignID) => {
    // Esnaf dashboard rotanı koruyorum
    navigate(`/dashboard/bol-para-esnaf/${companyID}/${campaignID}`);
  };

  // Kampanya kupon durumu kontrolü
  const checkCampaignHasCoupon = async (cid) => {
    try {
      const res = await Services.GetBolParaCampaignHasCoupon(token, cid);
      const ok = res?.data?.status === true;
      const result = res?.data?.result;

      if (!ok) return;

      if (result && typeof result === 'object') {
        setCampaignCoupons((prev) => ({
          ...prev,
          [cid]: { hasCoupon: Boolean(result.hasCoupon), hadCoupon: Boolean(result.hadCoupon) },
        }));
      } else {
        // result yoksa → kupon girildi ve VAR kabul ediyoruz (ilk sayfadakiyle aynı varsayım)
        setCampaignCoupons((prev) => ({
          ...prev,
          [cid]: { hasCoupon: true, hadCoupon: true },
        }));
      }
    } catch (_) {
      // Sessiz geçiyoruz (ilk sayfadaki gibi)
    }
  };

  // Şirket kampanyalarını çek
  const getCompanyCampaigns = () => {
    Services.GetBolParaCompanyCampaigns(token, companyID)
      .then((res) => {
        if (res.data?.status) {
          const today = Math.floor(Date.now() / 1000);
          const list = (res.data.result || []).filter(({ start, end }) => {
            const s = parseInt(start);
            const e = parseInt(end);
            return today >= s && today <= e;
          });
          setCampaigns(list);
        } else {
          setCampaigns([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // Token hakkında bilgi → poiID
  const getPoiID = () => {
    Services.BolParaAboutToken(token)
      .then((res) => {
        if (res.data?.status) {
          setPoiID(res.data?.result?.easypointID || '');
        }
      })
      .catch((err) => console.log(err));
  };

  // Şirket için kupon var mı?
  const checkCompanyHasCoupon = () => {
    setHasCoupon(null);
    setHadCoupon(null);

    Services.GetBolParaCompanyHasCoupon(token, companyID)
      .then((res) => {
        const status = res?.data?.status === true;
        if (!status) {
          setHasCoupon(false);
          setHadCoupon(false);
          return;
        }
        const result = res?.data?.result;
        if (result && typeof result === 'object') {
          const hc = Boolean(result.hasCoupon);
          const hd = Boolean(result.hadCoupon);
          setHasCoupon(hc);
          setHadCoupon(hd);
        } else {
          // result yoksa → kupon girildi ve VAR kabul ediyoruz
          setHasCoupon(true);
          setHadCoupon(true);
        }
      })
      .catch(() => {
        setHasCoupon(false);
        setHadCoupon(false);
      });
  };

  // Mount
  useEffect(() => {
    getCompanyCampaigns();
    getPoiID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Şirket kupon durumu paralelde
  useEffect(() => {
    checkCompanyHasCoupon();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyID, token]);

  // User office ID artık poiID üzerinden (ilk sayfadakiyle aynı mantık)
  const userOfficeId = poiID;

  // allowedPoints filtresi
  const filteredCampaigns = campaigns.filter((campaign) => {
    const points = Array.isArray(campaign.allowedPoints) ? campaign.allowedPoints : [];
    return points.includes(userOfficeId);
  });

  // Kampanya kupon durumlarını paralelde çek
  useEffect(() => {
    if (filteredCampaigns.length) {
      filteredCampaigns.forEach((c) => {
        if (!campaignCoupons[c.campaignID]) {
          checkCampaignHasCoupon(c.campaignID);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredCampaigns, token]);

  // Kupon talep etme
  const handleGetCouponClick = () => {
    setCouponError('');
    setCouponLoading(true);
    setCouponData(null);

    Services.GetNewCompanyCoupon(token, companyID, poiID)
      .then((res) => {
        if (res?.data?.status) {
          setCouponData(res.data.result || res.data);
          setCouponModalOpen(true);
          // Kupon alındı → şirket durumu tazele
          checkCompanyHasCoupon();
        } else {
          setCouponError('Kupon alınamadı. Lütfen tekrar deneyin.');
          setCouponModalOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setCouponError('Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.');
        setCouponModalOpen(true);
      })
      .finally(() => setCouponLoading(false));
  };

  // Kupon içeriği
  const renderCouponContent = () => {
    if (couponLoading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
          <CircularProgress />
        </div>
      );
    }
    if (couponError) {
      return <p style={{ color: '#e11d48', fontSize: 14 }}>{couponError}</p>;
    }
    if (!couponData) {
      return <p style={{ color: '#64748B', fontSize: 12 }}>Gösterilecek kupon bulunamadı.</p>;
    }

    const code = couponData.code || couponData.couponCode || couponData.CouponCode;
    const title = couponData.title || couponData.campaignTitle || (company?.title ? `${company.title} Kuponu` : 'Kupon');
    const description = couponData.description || couponData.desc;
    const expireDate = couponData.expireDate || couponData.expiration || couponData.validUntil;
    const qrUrl = couponData.qrUrl || couponData.qrCodeUrl || couponData.qr;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h3 style={{ margin: 0 }}>{title}</h3>
        {description && <p style={{ color: '#475569', margin: 0 }}>{description}</p>}
        {code && (
          <div
            style={{
              background: '#f1f5f9',
              border: '1px dashed #94a3b8',
              padding: '12px 16px',
              borderRadius: 8,
              fontWeight: 700,
              letterSpacing: 1.2,
              textAlign: 'center',
            }}
          >
            {code}
          </div>
        )}
        {expireDate && (
          <p style={{ color: '#64748B', fontSize: 12, margin: 0 }}>
            Son Kullanım: {expireDate}
          </p>
        )}
        {qrUrl && (
          <img
            src={qrUrl}
            alt="Kupon QR Kodu"
            style={{ alignSelf: 'center', maxWidth: 220, height: 'auto' }}
          />
        )}
        {!code && !description && !qrUrl && (
          <pre
            style={{
              background: '#0f172a',
              color: '#e2e8f0',
              padding: 12,
              borderRadius: 8,
              maxHeight: 300,
              overflow: 'auto',
            }}
          >
            {JSON.stringify(couponData, null, 2)}
          </pre>
        )}
      </div>
    );
  };

  // Modal stilleri (ilk sayfadaki ile aynı)
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: 24,
    position: 'relative',
  };

  const couponModalStyle = {
    ...modalStyle,
    width: '520px',
    maxWidth: '92vw',
  };

  return (
    <Box sx={{ p: 2 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '35%' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            component="img"
            src={company.logo}
            alt={`${company.title || 'Şirket'} logo`}
            sx={{ width: '25%', mt: 2, mb: 2, objectFit: 'contain' }}
          />

          {company.title !== 'Avon' ? (
            <>
              <Typography variant="h6" sx={{ color: '#494D59', fontWeight: 'bold' }}>
                {company.title} Paket Satışı Nasıl Yapılır?
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                sx={{ cursor: 'pointer', textDecoration: 'underline', my: 1 }}
                onClick={() => setModalOpen(true)}
              >
                Detayları görmek için tıklayın
              </Typography>
            </>
          ) : (
            <Typography variant="body2" sx={{ my: 1, width: '30%' }}>
              Selam sevgili esnaf dostum! Sana hem kazandıracak hem de mağazana renk katacak yepyeni bir fırsatımız var: Easy
              Point ile Avon markasını mağazanıza getiriyoruz! Hem müşterilerin memnun olacak hem senin ciron artacak. Nasıl mı?
              Alt kısımlarda yer alan işbirliği butonlarına tıklaman yeterli!
            </Typography>
          )}

          {/* Kupon butonu (şirket seviyesi) — ilk sayfadaki görünürlük kontrolüyle */}
          {company?.brandBasedGetCouponButtonVisibleStatus === '1' && (
            <>
              {hasCoupon === null ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <CircularProgress size={18} />
                  <span style={{ fontSize: 12, color: '#64748B' }}>Kupon uygunluğu kontrol ediliyor…</span>
                </div>
              ) : hasCoupon === true ? (
                <div style={{ marginTop: 16 }}>
                  <MUIButton
                    variant="contained"
                    sx={{ width: 400, mb: '30px' }}
                    onClick={handleGetCouponClick}
                    startIcon={<Iconify icon="solar:gift-bold" width={22} height={22} />}
                    disabled={couponLoading}
                  >
                    {couponLoading ? 'Kupon alınıyor...' : 'Kupon Al'}
                  </MUIButton>
                </div>
              ) : hadCoupon === true ? (
                <div style={{ marginTop: 16, textAlign: 'left',flexDirection:'column',display:'flex' }}>
                  <MUIButton
                    variant="contained"
                    sx={{ width: 400, mb: '6px' }}
                    onClick={handleGetCouponClick}
                    startIcon={<Iconify icon="solar:gift-bold" width={22} height={22} />}
                    disabled
                  >
                    Kupon Al
                  </MUIButton>
                  <Typography variant="caption" sx={{ color: '#98A2B3',width:'100%',alignItems:'center',justifyContent:'center',display:'flex' }}>
                    (İndirim Kodu Mevcut Değil. En Kısa Sürede Eklenecektir.)
                  </Typography>
                </div>
              ) : null}
            </>
          )}

          {/* Kampanyalar */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {filteredCampaigns.map((campaign) => {
              const cState = campaignCoupons[campaign.campaignID] || {};
              const isDepleted = cState.hadCoupon === true && cState.hasCoupon === false;

              return (
                <div key={campaign.campaignID} style={{ display: 'flex', flexDirection: 'column' }}>
                  <MUIButton
                    variant="contained"
                    sx={{ my: 1, width: 400, textAlign: 'left', justifyContent: 'flex-start' }}
                    onClick={() => handleCampaignClick(campaign.campaignID)}
                    startIcon={<Iconify icon="solar:add-circle-bold" width={24} height={24} />}
                    disabled={isDepleted}
                  >
                    {campaign.title}
                  </MUIButton>
                  {isDepleted && (
                  <Typography variant="caption" sx={{ color: '#98A2B3',width:'100%',alignItems:'center',justifyContent:'center',display:'flex' }}>
                      (İndirim Kodu Mevcut Değil. En Kısa Sürede Eklenecektir.)
                    </Typography>
                  )}
                </div>
              );
            })}
          </div>

          {/* Bilgilendirme Modalı — metin ilk sayfadakiyle birebir */}
          <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
            <Box sx={modalStyle}>
              <IconButton onClick={() => setModalOpen(false)} sx={{ position: 'absolute', top: 8, right: 8 }}>
                <Iconify icon="material-symbols:close" />
              </IconButton>
              <ol
                style={{
                  color: '#64748B',
                  fontWeight: 400,
                  fontSize: 12,
                  paddingLeft: 20,
                  marginTop: 40,
                }}
              >
                <li>
                  {company.title} Paket Seçin: Müşterilerinize sunmak için mevcut {company.title} paketlerinden birini seçin.
                </li>
                <li>
                  Paket Detaylarını Paylaşın: Seçtiğiniz paketlerin içeriklerini ve fiyatlarını müşterinize detaylı bir şekilde
                  aktarın.
                </li>
                <li>
                  Satışa Yönlendirin: Satışı tamamlamak için "QR Kodu Görüntüle" butonuna basın ve müşteriden kendi telefonundan
                  QR kodunu okutup gerekli bilgileri tamamlamasını isteyin. Ardından "Hemen Başvur" butonuna basmasını söyleyin.
                </li>
                <li>
                  Satışın Tamamlanması: Müşterinize, 48 saat içinde {company.title} merkezinin işlemleri tamamlamak için kendisini
                  arayacağı bilgisini iletin.
                </li>
                <li>Satışın Onaylanması: Eğer ilgili ekiplerinin araması sonucu satış olumlu olursa, kazanç sağlarsınız.</li>
                <li>Komisyon Kazanın: Her satıştan kazandığınız komisyonu Easy Point uygulamasında takip edebilirsiniz.</li>
              </ol>
            </Box>
          </Modal>

          {/* Kupon Modalı */}
          <Modal
            open={couponModalOpen}
            onClose={() => setCouponModalOpen(false)}
            aria-labelledby="coupon-modal-title"
            aria-describedby="coupon-modal-description"
          >
            <Box sx={couponModalStyle}>
              <IconButton
                onClick={() => setCouponModalOpen(false)}
                sx={{ position: 'absolute', top: 8, right: 8 }}
                aria-label="Kapat"
              >
                <Iconify icon="material-symbols:close" />
              </IconButton>
              <div style={{ marginTop: 24 }}>{renderCouponContent()}</div>
            </Box>
          </Modal>
        </Box>
      )}
    </Box>
  );
}